export const TRANSLATIONS_PT = {
  "routes_Pages": "Páginas",
  "routes_Dashboard": "Painel de controlo",
  "routes_Questionnaire": "Normas",
  "routes_Stats": "Estatísticas",
  "routes_Settings": "Definições",
  "routes_Resouces": "Recursos",
  "routes_Contact": "Contacto",
  "routes_Downloads": "Transferências",
  "routes_Documentation": "Documentação",
  "dashboard_welcome_message": "Bem-vindo ao Painel de Controlo do Sistema de Gestão da Acessibilidade 👋",
  "dashboard_label": "Todos os seus dados de acessibilidade reunidos, estruturados e monitorizados num único local.",
  "gettingStartedCard_gettingStarted": "Começar a trabalhar",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesque",
  "gettingStartedCard_Steps": "Para começar, recomendamos estes passos:",
  "gettingStartedCard_step1": "Ler a documentação",
  "gettingStartedCard_step2": "Descarregar a lista de controlo",
  "gettingStartedCard_step3": "Verificar as estatísticas",
  "companyCard_supportedStandards": "Normas suportadas:",
  "companyCard_companyInformation": "Informações sobre a empresa",
  "companyCard_numberOfEmployees": "empregados",
  "propertyListPage_propertyList": "Lista de propriedades",
  "propertyListPage_dashboard": "Painel de controlo",
  "propertyListPage_Questionnaire": "Normas",
  "propertyListPage_newProperty": "Nova propriedade",
  "propertyListPage_textmapEdit": "Editar propriedade",
  "propertyListPage_textmapQuestionnaire": "Classificar",
  "propertyListPage_textmapFacility": "Editar facilidade",
  "propertyListPage_textmapNewProperty": "Nova propriedade",
  "propertyListPage_createNewProperty": "Criar nova propriedade",
  "propertyListPage_disabilityClassification": "Classificação da deficiência",
  "propertyListPage_editProperty": "Editar propriedade",
  "propertyListPage_editFacilities": "Editar instalações",
  "propertyListPage_classify": "Classificar",
  "propertyListPage_search": "Pesquisa por nome do imóvel",
  "propertyForm_propertyInformation": "1.1 Informações sobre o imóvel",
  "propertyForm_standardType": "Tipo padrão",
  "propertyForm_fieldCannotBeChanged": "Este campo não pode ser alterado",
  "propertyForm_propertyCategory": "Categoria do imóvel",
  "propertyForm_typeOfProperty": "Tipo de propriedade",
  "propertyForm_propertyName": "Nome do imóvel",
  "propertyForm_propertyArea": "Quantidade de metros quadrados de superfície de pavimento",
  "propertyForm_enterPropertyAddress": "1.1.2 Introduzir o endereço do imóvel",
  "propertyForm_addressLocation": "Escreva a localização do endereço abaixo",
  "propertyForm_mapNote": "Se necessário, pode ajustar o mapa para que o pino fique na localização correcta",
  "propertyForm_keyPropertyData": "1.2 Principais dados de propriedade",
  "propertyForm_floorsQuestion": "Quantos pisos tem o seu imóvel?",
  "propertyForm_roomsQuestion": "Quantas divisões tem o seu imóvel?",
  "propertyForm_disabledRoomsQuestion": "Quantos quartos para deficientes tem o seu estabelecimento?",
  "propertyForm_alergyRoomsQuestion": "Quantos quartos para alérgicos tem a sua propriedade?",
  "propertyForm_save": "Guardar",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Doces",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Jornais",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Produtos de tabaco",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Produtos de higiene pessoal",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Loja",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermercado",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Vestuário",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Loja_departamento",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Eletrónica",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Jardim",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Bens de uso doméstico",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Animais de estimação",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Brinquedos",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Padaria e loja de produtos de pastelaria",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Produtos lácteos",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Alimentação e bebidas",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Loja especializada em alimentos e bebidas",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Mercearia",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Carne",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Loja de especialidades alimentares",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegan",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetariano",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Vinho e bebidas alcoólicas",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Farmácia",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Farmácia",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Computador e software",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Loja de eletrónica de consumo",
  "propertyForm_propertyElectronicsOptions_electronics": "Eletrónica",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Entretenimento_electrónica",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Retalhista móvel",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Centro de serviço móvel",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Galeria comercial",
  "propertyForm_propertyMallOptions_shopping_mall": "Centro comercial",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Centro comercial",
  "propertyForm_standardTypeOptions_shop": "Loja",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Chão e alcatifa",
  "propertyForm_propertyHardwareOptions_furniture_store": "Loja de móveis",
  "propertyForm_propertyHardwareOptions_garden_center": "Centro de jardinagem",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Vidros e janelas",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Jardim da casa de ferragens",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Loja de ferragens para melhoramento da casa",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Loja especializada em casa",
  "propertyForm_propertyHardwareOptions_lumber": "Madeira serrada",
  "propertyForm_propertyHardwareOptions_major_appliance": "Grandes electrodomésticos",
  "propertyForm_propertyHardwareOptions_paint_store": "Loja de tintas",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Revendedor de equipamento elétrico",
  "propertyForm_propertyBookstoreOptions_bookstore": "Livraria",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Vestuário para criança",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Vestuário e acessórios",
  "propertyForm_propertyClothingOptions_mens_apparel": "Vestuário para homem",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Calçado calçado",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Loja de roupa especializada",
  "propertyForm_propertyClothingOptions_womens_apparel": "Vestuário para senhora",
  "propertyForm_consumerGoodsOptions_adult_shop": "Loja para adultos",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Material para artesanato",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Loja de bicicletas e acessórios para bicicletas",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Loja de campismo e caminhadas",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Loja de canoas e caiaques",
  "propertyForm_consumerGoodsOptions_car_accessories": "Acessórios para automóveis",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Bens de consumo",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Loja de esqui de fundo",
  "propertyForm_consumerGoodsOptions_florist": "Florista",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Mercadoria geral",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Prenda arte antiga",
  "propertyForm_consumerGoodsOptions_hobby_store": "Loja de passatempos",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Loja de caça e pesca",
  "propertyForm_consumerGoodsOptions_jeweler": "Joalheiro",
  "propertyForm_consumerGoodsOptions_market": "Mercado",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Acessórios para motociclos",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Retalhistas sem loja",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Loja de material de escritório",
  "propertyForm_consumerGoodsOptions_pawnshop": "Loja de penhores",
  "propertyForm_consumerGoodsOptions_pet_supply": "Fornecimento para animais de estimação",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Gravar vídeo cd",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Loja de artigos para caminhadas",
  "propertyForm_consumerGoodsOptions_skate_shop": "Loja de skate",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Loja de esqui e snowboard",
  "propertyForm_consumerGoodsOptions_specialty_store": "Loja de especialidade",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Loja de artigos desportivos",
  "propertyForm_consumerGoodsOptions_surf_shop": "Loja de surf",
  "propertyForm_consumerGoodsOptions_tack_shop": "Loja de arreios",
  "propertyForm_consumerGoodsOptions_toy_store": "Loja de brinquedos",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Lojas de artigos usados em segunda mão",
  "propertyForm_consumerGoodsOptions_variety_store": "Loja de variedades",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Aluguer de vídeos e jogos",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Armazém grossista",
  "propertyForm_hairAndBeautyOptions_barber": "Barbeiro",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Cabelo e beleza",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Salão de cabeleireiro",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Salão de unhas",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Salão de maquilhagem",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Complexo comercial Mall",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Loja de conveniência",
  "propertyForm_shopCategoryOptions_department_store": "Loja de departamentos",
  "propertyForm_shopCategoryOptions_food_and_drink": "Alimentação e bebidas",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Drogaria ou farmácia",
  "propertyForm_shopCategoryOptions_electronics": "Eletrónica",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Jardim da casa de ferragens",
  "propertyForm_shopCategoryOptions_bookstore": "Livraria",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Vestuário e acessórios",
  "propertyForm_shopCategoryOptions_consumer_goods": "Bens de consumo",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Cabelo e beleza",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "facilitiesForm_standardTypeOptions_office": "Escritório",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Centro comercial",
  "facilitiesForm_standardTypeOptions_shop": "Loja",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Selecionar as instalações para a recolha de dados",
  "facilitiesForm_preselectedMandatoryItems": "Os seguintes elementos pré-seleccionados são obrigatórios",
  "facilitiesForm_mandatoryFacilitiesFor": "Instalações obrigatórias para",
  "facilitiesForm_optionalFacilitiesFor": "Instalações opcionais para",
  "facilitiesForm_standard": "Padrão",
  "facilitiesForm_preselectedOptionalItems": "Os seguintes elementos são facultativos",
  "facilitiesForm_faq_mandatoryFacilities": "O que são instalações obrigatórias?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Estas são instalações normais que encontramos em imóveis do seu género. Para gerar os nossos dados de acessibilidade de uma forma exaustiva, estas instalações têm de ser avaliadas. EX a entrada do edifício",
  "facilitiesForm_faq_optionalFacilities": "O que são instalações opcionais?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Esta é uma lista não exaustiva de instalações que podem existir ou não na sua propriedade, mas que não são necessariamente instalações padrão numa propriedade como a sua. Por exemplo, um spa num hotel ou num centro comercial.",
  "unitForm_helperText_entrance_key": "Entrada",
  "unitForm_helperText_entrance_value": "Ou seja, entrada principal ou entradas secundárias, como por exemplo através do restaurante ou dos jardins",
  "unitForm_helperText_lobby_key": "Lobby",
  "unitForm_helperText_lobby_value": "i.e. Átrio principal da propriedade, incluindo sala de estar ou área de espera",
  "unitForm_helperText_reception_key": "Receção/balcão de informações",
  "unitForm_helperText_reception_value": "Ou seja, o balcão principal de check-in, o balcão de concierge, a área de depósito de bagagens ou as áreas do balcão de informações",
  "unitForm_helperText_facility_key": "Instalações",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Estacionamento e arredores próximos",
  "unitForm_helperText_parking_value": "Ou seja, área de estacionamento principal e áreas exteriores adicionais, tais como jardins, entradas de garagem, passeios",
  "unitForm_helperText_commonAreas_key": "Áreas comuns",
  "unitForm_helperText_commonAreas_value": "Áreas públicas partilhadas do hotel, como o Lobby Lounge, corredores, etc.",
  "unitForm_helperText_conferenceRoom_key": "Sala de conferências / sala de reuniões",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Auditório",
  "unitForm_helperText_auditorium_value": "Espaço de teatro, cinema, etc.",
  "unitForm_helperText_diningArea_key": "Área de refeições",
  "unitForm_helperText_diningArea_value": "Por exemplo, restaurante principal, área de buffet de pequeno-almoço, Lobby Bar / Bistro",
  "unitForm_helperText_toiletRoom_key": "Casa de banho (comum, partilhada)",
  "unitForm_helperText_toiletRoom_value": "i.e. Casa de banho partilhada acessível a partir do átrio, restaurante ou outras áreas públicas",
  "unitForm_helperText_gym_key": "Ginásio",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Tipo de quarto de hotelaria",
  "unitForm_helperText_hospitalityRoom_value": "i.e. Tipo de quarto, por exemplo, individual, duplo, acessível, familiar, etc.",
  "unitForm_quantityLabel": "Selecionar a quantidade",
  "unitForm_locationFaq": "Onde se situa?",
  "unitForm_totalQuantity": "Quantidade total",
  "unitForm_floorSelection": "Selecionar o piso",
  "unitForm_finishedCreation": "Já acabou de criar unidades?",
  "unitForm_startClassifying": "Questionários!",
  "unitForm_unitData2": "Casa de banho privativa",
  "unitForm_unitData3": "Casa de banho privativa",
  "unitForm_unitData4": "Cozinha privada",
  "unitForm_unitTypeDetails": "3. Detalhes do tipo de unidade:",
  "unitForm_unitName": "Escreva aqui o nome da sua unidade",
  "unitForm_accessibleUnit": "Esta unidade é considerada acessível",
  "questionUnits_addNewUnit": "Adicionar nova unidade",
  "questionUnits_savedInfo": "A sua informação foi guardada",
  "questionUnits_removedInfo": "A sua informação foi removida",
  "questionUnits_resources": "Recursos",
  "questionUnits_uploadPictures": "Carregar imagens",
  "questionUnits_explanation": "Algumas explicações / detalhes sobre esta secção podem ser consultados aqui",
  "questionUnits_uploadLabel": "CARREGAR",
  "questionUnits_unitExtraInfo": "Unidade Informações adicionais",
  "questionUnits_unitExtraInfoPlaceholder1": "Aqui pode inserir comentários privados para esta unidade específica",
  "questionUnits_unitExtraInfoPlaceholder2": "( atualmente não tem comentários sobre esta unidade )",
  "questionUnits_beforeClassification": "É necessário acrescentar instalações antes de começar a classificar",
  "questionUnits_editFacilities": "Editar instalações",
  "questionUnits_addNew": "Clique em \"Adicionar novo\" ou seleccione a unidade para começar a classificar",
  "questionUnits_faq1": "Informações",
  "questionUnits_faq2": "O que são instalações obrigatórias?",
  "questionUnits_faq2_1": "Estas são instalações normais que encontramos em imóveis do seu género. Para gerar os nossos dados de acessibilidade de uma forma exaustiva, estas instalações têm de ser avaliadas. EX a entrada do edifício",
  "questionUnits_faq3": "O que são instalações opcionais?",
  "questionUnits_faq3_1": "Esta é uma lista não exaustiva de instalações que podem existir ou não na sua propriedade, mas que não são necessariamente instalações padrão numa propriedade como a sua. Por exemplo, um spa num hotel ou num centro comercial.",
  "FAR_SelectProperty": "Selecionar propriedade",
  "FAR_DocumentPreview": "Pré-visualização do documento:",
  "FAR_DownloadPDF": "Descarregar PDF:",
  "FAR_Download": "Descarregar agora!",
  "CLP_SelectProperty": "Selecionar propriedade",
  "CLP_SelectPropertyForChecklist": "Selecionar um imóvel para criar a lista de verificação",
  "CLP_AccessibilityChecklist": "Lista de controlo da acessibilidade",
  "CLP_GeneratedOn": "Gerado em ",
  "CLP_GeneratedBy": "Gerado por ",
  "CLP_LoadingDoc": "Carregar documento...",
  "CLP_DownloadNow": "Descarregar agora!",
  "A11yUnitsPageSubTitle": "Aspectos a ter em conta",
  "A11yUnitsPageDescription": "Só é possível associar unidades semelhantes umas às outras se forem exatamente iguais. Caso contrário, deve ser criado outro tipo de unidade.",
  "routes_NewProperty": "Nova propriedade",
  "routes_EditProperty": "Editar propriedade",
  "routes_EditFacility": "Editar facilidade",
  "routes_SelectFacilities": "Selecionar instalações",
  "routes_CreateProperty": "Criar propriedade",
  "routes_Classify": "Classificar",
  "routes_Blank": "Em branco",
  "changePassword_success": "Sucesso",
  "changePassword_successMessage": "A sua palavra-passe foi actualizada",
  "changePassword_returnToLogin": "Regressar ao início de sessão",
  "changePassword_resetPassword": "Redefinir a sua palavra-passe",
  "changePassword_newPassword_label": "Nova palavra-passe",
  "changePassword_confirmNewPassword_label": "Confirmar a nova palavra-passe",
  "changePassword_newPasswordRequired_errorMessage": "É necessária uma nova palavra-passe",
  "changePassword_newPasswordMismatch_errorMessage": "As palavras-passe devem corresponder",
  "changePassword_newPassword_browserTab": "Alterar a palavra-passe",
  "DocumentationPage_pageTitle": "Página de documentação",
  "DocumentationPage_tabtitle": "Documentação",
  "DownloadsPage_pageTitle": "Página de transferências",
  "LanguagesDropdown_English": "Inglês",
  "LanguagesDropdown_French": "francês",
  "LanguagesDropdown_German": "alemão",
  "LanguagesDropdown_Dutch": "holandês",
  "LocationAutocomplete_searchPlaceholder": "Procurar locais ...",
  "LocationAutocomplete_validAddress": "Indicar o número da casa e a rua",
  "LocationAutocomplete_addressEmpty": "O endereço não pode estar vazio",
  "page404_PageNotFound": "Página não encontrada.",
  "page404_PageNotFound_explanation": "A página que procura pode ter sido removida.",
  "page404_PageNotFound_returnHome_button": "Regressar ao sítio Web",
  "page500_InternalError": "Erro interno do servidor.",
  "page500_InternalError_explanation": "O servidor está a ser utilizado de forma a que o utilizador possa ter acesso a um pedido.",
  "propertyListPage_NotClassified": "Não classificado",
  "propertyListIconName_allergy_food_class": "Aula sobre alergia alimentar",
  "propertyListIconName_allergy_room_class": "Aula de sala de alergia",
  "propertyListIconName_mobility_class": "Aula de mobilidade",
  "propertyListIconName_hearing_class": "Aula de audição",
  "propertyListIconName_cognitive_class": "Classe Cognitiva",
  "propertyListIconName_visual_class": "Classe visual",
  "propertyForm_AllStepsCompleted": "Todas as etapas concluídas",
  "propertyForm_propertyReady": "O seu imóvel já está pronto!",
  "propertyForm_propertyReady_description": "Terminou o passo relativo às informações sobre o imóvel. Pode editar estas informações clicando na ligação Lista de bens no painel superior esquerdo.",
  "propertyForm_startClassifying": "COMEÇAR A CLASSIFICAR",
  "propertyForm_propertyStepper_step1": "Adicionar informações sobre o imóvel",
  "propertyForm_propertyStepper_step2": "Selecionar instalações",
  "propertyForm_propertyStepper_step3": "Adicionar detalhes da unidade",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Serviço",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Merchandising",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Fabrico",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Outros",
  "settingsForms_ImageCantBeChanged": "Esta imagem não pode ser alterada",
  "settingsForms_RegNumber_label": "Número de registo",
  "settingsForms_InvoiceStatus_label": "Estado da fatura",
  "settingsForms_CompanyName_label": "Nome da empresa",
  "settingsForms_CompanyType_label": "Tipo de empresa",
  "settingsForms_CompanySize_label": "Dimensão da empresa",
  "settingsForms_CompanyAddress_label": "Endereço da empresa",
  "settingsForms_ContractDate_label": "Data de assinatura do contrato",
  "settingsForms_SubscriptionPeriod_label": "Período de subscrição",
  "settingsForms_Employees_label": "Empregados",
  "settingsForms_UserInformation_positionOptions_owner": "Proprietário",
  "settingsForms_UserInformation_positionOptions_executive": "Executivo",
  "settingsForms_UserInformation_positionOptions_manager": "Diretor",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Operações e produção",
  "settingsForms_UserInformation_positionOptions_other": "Outros",
  "settingsForms_UserInformation_departmentOptions_it": "TI",
  "settingsForms_UserInformation_departmentOptions_marketing": "Marketing",
  "settingsForms_UserInformation_departmentOptions_finance": "Finanças",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Recursos humanos",
  "settingsForms_UserInformation_departmentOptions_sales": "Vendas",
  "settingsForms_UserInformation_departmentOptions_operations": "Operações",
  "settingsForms_UserInformation_departmentOptions_other": "Outros",
  "settingsForms_UserInformation_title": "Informações do utilizador",
  "settingsForms_UserInformation_UploadPicture": "Carregar imagem",
  "settingsForms_UserInformation_formatRestriction": "Utilizar uma imagem com pelo menos 128px por 128px em formato .jpg",
  "settingsForms_UserInformation_surname": "Apelido",
  "settingsForms_UserInformation_position": "Posição",
  "settingsForms_UserInformation_department": "Departamento",
  "settingsPage_pageTitle": "Página de definições",
  "settingsPage_breadcrumbs_dashboard": "Painel de controlo",
  "settingsPage_breadcrumbs_settings": "Definições",
  "signinForm_explanation": "Inicie sessão na sua conta para continuar",
  "signinForm_validEmail_error": "Deve ser um correio eletrónico válido",
  "signinForm_emailRequired": "O correio eletrónico é obrigatório",
  "signinForm_generalError": "Algo correu mal",
  "signinForm_passwordRequired": "É necessária uma palavra-passe",
  "signinForm_emailLabel_textfield": "Endereço de correio eletrónico",
  "signinForm_passwordLabel_textfield": "Palavra-passe",
  "signinForm_remberMeCheckbox_textfield": "Lembrar-se de mim",
  "signinForm_signIn_button": "Iniciar sessão",
  "signinForm_forgotPassword_button": "Esqueci-me da palavra-passe",
  "signupForm_signUp_button": "Inscrever-se",
  "signupForm_signUp_title": "Começar a trabalhar",
  "signupForm_signUp_subTitle": "Comece a criar a melhor experiência de utilizador possível para os seus clientes",
  "signupForm_signUp_nameRequired": "O nome é obrigatório",
  "signupForm_signUp_minCharacters_errorMessage": "Deve ter pelo menos 12 caracteres",
  "signupForm_signUp_required_errorMessage": "Necessário",
  "signupForm_signUp_nameLabel": "Nome",
  "signupForm_signUp_companyLabel": "Empresa",
  "signupForm_signUp_emailAddressLabel": "Endereço de correio eletrónico",
  "signupForm_signUp_passwordLabel": "Palavra-passe",
  "signupForm_signUp_confirmPasswordLabel": "Confirmar a palavra-passe",
  "statsPage_pageTitle": "Página de estatísticas",
  "statsPage_cardContent": "Esta página estará disponível em futuras versões do Sistema de Gestão da Acessibilidade.",
  "resetPassword_inbox": "Verificar a sua caixa de entrada",
  "resetPassword_explanation_1": "Enviámos uma mensagem de correio eletrónico para",
  "resetPassword_explanation_2": "com instruções para restaurar a palavra-passe",
  "resetPassword_title": "Repor a palavra-passe",
  "resetPassword_subTitle": "Introduza o seu e-mail para redefinir a sua palavra-passe",
  "unitForm_title": "Unidades compostas",
  "unitForm_floorTitle": "Piso",
  "unitImagesDialog_labelMANDATORY": "OBRIGATÓRIO",
  "unitImagesDialog_labelOPTIONAL": "FACULTATIVO",
  "unitImagesDialog_labelPICTURES": "FOTOS",
  "unitImagesDialog_dropzone": "Deixar imagens aqui ou escolher um ficheiro",
  "userDropdown_profile": "Perfil",
  "userDropdown_signout": "Sair",
  "questionUnits_uploadPictures_uploadError": "Ocorreu um erro ao carregar as imagens",
  "questionUnits_uploadSuccess": "Os seus dados foram submetidos com sucesso",
  "questionUnits_unitExtraInfoLabel": "Informações adicionais",
  "questionUnits_unitExtraInfoDelete_button": "Eliminar",
  "questionUnits_unitExtraInfoSave_button": "Guardar",
  "QuestionnaireCompletionCard_title": "Conclusão das normas",
  "QuestionnaireCompletionCard_disableMessage": "Ainda não tem nenhuma classificação.",
  "QuestionnaireCompletionCard_ParkingCard": "Estacionamento",
  "QuestionnaireCompletionCard_EntranceCard": "Entrada",
  "QuestionnaireCompletionCard_ToiletCard": "Sanita",
  "QuestionnaireCompletionCard_RoomsCard": "Quartos",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Elevadores e ascensores",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Átrio e receção",
  "FAR_Report": "Relatório de acessibilidade",
  "FAR_TableUnitName": "Nome da unidade",
  "FAR_TableDescription": "Descrição",
  "CLP_PleaseSelectProperty": "Seleccione o imóvel",
  "CLP_BrowserTabTitle": "Relatório completo de acessibilidade ",
  "CLP_UnitMandatoryLabel": "Obrigatório",
  "CLP_UnitDoneLabel": "FEITO",
  "propertyPage_Controllers_SearchDoc": "Pesquisar documentação",
  "generalWords_Yes": "Sim",
  "generalWords_No": "Não",
  "generalWords_Next": "Seguinte",
  "generalWords_Close": "Fechar",
  "generalWords_Reset": "Reiniciar",
  "generalWords_Back": "Voltar",
  "generalWords_Finish": "Acabamento",
  "generalWords_NextStep": "Próxima etapa",
  "generalWords_Edit": "Editar",
  "generalWords_Download": "Descarregar",
  "generalWords_Delete": "Eliminar",
  "generalWords_SaveChanges": "Guardar alterações",
  "generalWords_Selected": "selecionado",
  "generalWords_Required": "Necessário",
  "customerSupportPage_title": "Página de apoio ao cliente",
  "customerSupportPage_emailLabel": "Contactar o apoio ao cliente em:",
  "unitForm_helperText_entrance": "Ou seja, entrada principal ou entradas secundárias, tais como via restaurante ou jardins.",
  "unitForm_helperText_lobby": "Ou seja, o átrio principal da propriedade, incluindo a sala de estar ou a área de espera.",
  "unitForm_helperText_reception": "Ou seja, o balcão principal de check-in, o balcão de concierge, a área de depósito de bagagens ou as áreas do balcão de informações.",
  "unitForm_helperText_facility": "i.e. O nome da instalação ou da propriedade.",
  "unitForm_helperText_parking": "Ou seja, área de estacionamento principal e áreas exteriores adicionais, tais como jardins, entradas de garagem, passeios.",
  "unitForm_helperText_conferenceRoom": "Uma sala de conferências é uma sala grande onde várias pessoas podem realizar uma conferência.",
  "unitForm_helperText_auditorium": "Espaço de teatro, cinema, etc.",
  "unitForm_helperText_diningArea": "Por exemplo, restaurante principal, área de buffet de pequeno-almoço, Lobby Bar / Bistro.",
  "unitForm_helperText_toiletRoom": "Ou seja, casa de banho partilhada/casa de banho acessível a partir do átrio, restaurante ou outras áreas públicas.",
  "unitForm_helperText_gym": "Exercícios e actividades físicas realizados no interior, muitas vezes com recurso a equipamento.",
  "unitForm_helperText_spa": "Local onde se pode relaxar através de uma sauna, piscina e jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "i.e. Tipo de quarto, por exemplo, individual, duplo, acessível, familiar, etc.",
  "unitForm_helperText_shopping_aisle": "ou seja, o corredor entre as prateleiras.",
  "unitForm_helperText_counter": "Uma superfície plana (como uma mesa, uma prateleira ou uma vitrina) sobre a qual são efectuadas transacções.",
  "unitForm_helperText_checkout_pay": "Por exemplo, caixa de saída, caixa de saída automática, caixa de saída com leitura ótica automática.",
  "unitForm_helperText_fitting_room": "Uma sala numa loja onde os clientes podem vestir uma peça de roupa para ver se lhes serve antes de a comprarem.",
  "unitForm_helperText_manned_kiosk": "Um terminal de troca ou de resgate de dinheiro, que permite efetuar transacções em dinheiro e sem dinheiro com um caixa.",
  "unitForm_helperText_floor": "Ou seja, a acessibilidade em diferentes níveis, como o elevador no 1.º andar e o elevador verde na entrada 2.",
  "unitForm_helperText_playground": "Uma área utilizada pelas crianças para brincar. Normalmente, têm equipamento como escorregas, baloiços e balancés para as crianças brincarem.",
  "unitForm_helperText_garden": "Um espaço, geralmente ao ar livre, reservado para o cultivo, exposição e apreciação de plantas e outras formas de natureza.",
  "unitForm_helperText_bathroom_common": "Quarto que contém uma banheira ou chuveiro e, normalmente, um lavatório e uma sanita.",
  "unitForm_helperText_bathroom__private": "Um quarto privado com uma banheira ou chuveiro e, normalmente, um lavatório e uma sanita.",
  "unitForm_helperText_quiet_room": "Uma sala tranquila ou sala silenciosa é uma sala construída tendo em conta o silêncio, protegendo o ruído do ambiente ou em direção ao mesmo.",
  "unitForm_helperText_kitchen_common": "Uma sala pública onde se podem preparar e cozinhar alimentos.",
  "unitForm_helperText_toilet_room__private": "ou seja, casa de banho privada acessível a partir do átrio, restaurante ou outras áreas públicas.",
  "unitForm_helperText_kitchen__private": "Uma sala privada onde se pode preparar e cozinhar alimentos.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Serviços",
  "routes_Help": "Ajuda",
  "routes_Clp": "Lista de controlo",
  "routes_Far": "Relatório de acessibilidade",
  "FAR_WhatIsItTitle": "O que é um relatório de acessibilidade?",
  "FAR_WhatIsItDescription": "O relatório de acessibilidade é um relatório que geramos para si em função do grau de acessibilidade do seu imóvel. Abaixo, pode selecionar um imóvel e descarregar o respetivo relatório em PDF.",
  "FAR_MoreInfo": "Para mais informações sobre o Relatório de Acessibilidade, consultar",
  "FAR_SelectPropertyForChecklist": "Selecionar uma propriedade para criar o relatório",
  "CLP_noChecklistFound": "Não foi possível encontrar uma lista para este imóvel",
  "CLP_WhatIsItTitle": "O que é uma lista de controlo?",
  "CLP_WhatIsItDescription": "A lista de verificação é uma lista baseada nas informações do inventário do sistema de acessibilidade. Mostra as áreas de melhoria, com base na sua entrada no sistema. Está disponível uma pré-visualização do documento, que pode ser descarregada ou impressa.",
  "CLP_MoreInfo": "Para mais informações sobre a lista de controlo, consultar",
  "CLP_FAR_ConsultTheDocumentation": "consultar a documentação",
  "LanguagesDropdown_Swedish": "Sueco",
  "LanguagesDropdown_Danish": "Dinamarquesa",
  "gettingStartedCard_step1_link": "Ler",
  "gettingStartedCard_step2_link": "Descarregar",
  "gettingStartedCard_step3_link": "Verificar",
  "contactForm_category": "Categoria",
  "contactForm_title": "Contactar-nos",
  "contactForm_chooseImg": "Selecionar imagem",
  "contactForm_submitBtn": "Enviar pedido",
  "contactForm_attachBtnLabel": "Se possível, anexe uma captura de ecrã.",
  "contactForm_messageLabel": "Descreva aqui o seu pedido.",
  "contactForm_messageEmptyError": "Adicionar uma mensagem",
  "contactForm_categoryOptions_ServiceInquiry": "Inquérito de serviço",
  "contactForm_categoryOptions_TechnicalIssues": "Questões técnicas",
  "contactForm_categoryOptions_OtherInquires": "Outros inquéritos",
  "contactForm_subtitle1": "Se não conseguir encontrar a resposta que procura, estamos aqui para o ajudar.",
  "contactForm_subtitle2": "Por favor, escreva-nos! Entraremos em contacto consigo o mais rapidamente possível.",
  "FAR_noDataAvalible_1": "O relatório de acessibilidade ainda não pode ser gerado para este imóvel. Por favor, preencha o",
  "FAR_noDataAvalible_2": "para",
  "FAR_noDataAvalible_3": "primeiro.",
  "CLP_Updating": "Atualização...",
  "CLP_AreYouSure": "Tens a certeza?",
  "CLP_UpdateMessage": "Se o fizer, o item desaparecerá da lista de verificação e a norma será automaticamente actualizada, reflectindo a alteração.",
  "CLP_Cancel": "CANCELAR",
  "CLP_YesUpdate": "SIM, ACTUALIZAR",
  "CLP_WhatIsAChecklist": "O que é uma lista de controlo?",
  "CLP_Name": "Nome",
  "CLP_pdfDisclaimer": "Nota: Depois de efetuar as melhorias, não se esqueça de atualizar os seus dados de acessibilidade na secção padrão.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Não dispomos de dados de acessibilidade. ",
  "CLP_noChecklist1": "A lista de controlo ainda não pode ser gerada para este imóvel. Responda às perguntas dentro da ",
  "CLP_noChecklist2": "secção normalizada ",
  "CLP_noChecklist3": "para",
  "CLP_noChecklist4": "primeiro.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Criar um imóvel",
  "CLP_FAR_noAccessibilityDataAvailable3": " e responder primeiro às perguntas da secção normal.",
  "statsPage_subscriptionExpiring": "Assinatura que expira em",
  "statsPage_days": "dias",
  "statsPage_contactCustomerSupport": "Contactar o Apoio ao Cliente",
  "statsPage_companyInformation": "Informações sobre a empresa",
  "statsPage_numberOfPhotosUploaded": "Número de fotografias carregadas",
  "statsPage_photos": "fotos",
  "statsPage_totalAmountProperties": "Montante total de propriedades",
  "statsPage_amountCompleted": "Montante realizado",
  "statsPage_actionsPerVisitor": "Acções por visitante no Widget",
  "statsPage_yourItems": "Os seus artigos",
  "statsPage_name": "Nome",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Quantidade",
  "statsPage_numberOfUnits": "Número de unidades",
  "statsPage_accessible": "Acessível",
  "statsPage_notAccessible": "Não acessível",
  "statsPage_unit": "Unidade",
  "statsPage_amount": "Montante",
  "statsPage_incomplete": "Incompleto",
  "statsPage_completed": "Concluído",
  "statsPage_notCompleted": "Não concluído",
  "statsPage_mobility": "Mobilidade",
  "statsPage_cognitive": "Cognitivo",
  "statsPage_hearing": "Audição",
  "statsPage_visual": "Visual",
  "statsPage_allergy": "Alergia",
  "statsPage_class": "Classe",
  "statsPage_totalAccessibilityDatapoints": "Total de pontos de dados de acessibilidade",
  "statsPage_visitorsThatOpened": "Visitantes que abriram o Widget",
  "statsPage_visitorsInteraction": "Total de acções no Widget",
  "statsPage_action": "Ação",
  "statsPage_clicks": "Cliques",
  "statsPage_noDataAvailable_topText": "Não existem dados disponíveis",
  "statsPage_noDataAvailable_bottomText": "No momento",
  "statsPage_company_address": "Endereço",
  "statsPage_company_city": "Cidade",
  "statsPage_company_country": "País",
  "statsPage_company_name": "Nome",
  "statsPage_company_type": "Tipo",
  "statsPage_company_registration_number": "Número de registo",
  "statsPage_company_logo": "Logótipo",
  "statsPage_company_employees": "Empregados",
  "statsPage_company_empty_fields": "Campos vazios",
  "settingsPage_alertMsgImageUpload": "Clique em guardar para atualizar a sua imagem de perfil",
  "settingsPage_alertMsgCompanyInformation_1": "Contacto",
  "settingsPage_alertMsgCompanyInformation_2": "Apoio ao cliente",
  "settingsPage_alertMsgCompanyInformation_3": "se necessitar de efetuar alterações às Informações da empresa.",
  "documentationPage_downloadDocument": "Descarregar o documento",
  "documentationPage_loadingDocument": "Carregar documento",
  "CLP_Status": "Estado",
  "CLP_lastUpdate": "Última atualização",
  "CLP_completed": "concluído",
  "CLP_incomplete": "incompleto",
  "LanguagesDropdown_Languages": "Línguas",
  "login_welcome_message": "Bem-vindo ao Sistema de Gestão da Acessibilidade 👋",
  "CLP_Checklist_is_generated_based": "A lista de verificação é gerada com base nos dados de acessibilidade que recolhemos da sua propriedade. Mostra as áreas a melhorar e, assim que assinalar o ponto, a resposta é automaticamente actualizada no sistema e os seus dados de acessibilidade serão alterados. O documento pode ser descarregado para uso externo. Para mais informações",
  "CLP_Go_to_checklist": "Ir para a lista de controlo",
  "CLP_Updated_date": "Data de atualização",
  "CLP_The_purpose_of_Handiscover_1": "O objetivo do inventário e da lista de verificação da Handiscover é orientá-lo na melhoria da sua acessibilidade. A lista em anexo é composta por vários pontos. Na perspetiva de que algo deve ser adaptado à acessibilidade, há pontos que são obrigatórios. Para além disso, identificamos pontos como os que recomendamos, quer se trate de construção nova ou de renovação.",
  "CLP_List_points": "Listar pontos",
  "CLP_Priority": "Prioridade",
  "CLP_User": "Utilizador",
  "CLP_Mandatory": "Obrigatório",
  "CLP_Need_help": "Precisa de ajuda? Contacte a nossa equipa",
  "CLP_Handiscovers_suggestions": "Sugestões da Handiscover",
  "propertyForm_nextStep_tooltip": "Preencher primeiro todos os campos obrigatórios",
  "statsPage_See_photos": "Ver fotos",
  "statsPage_Your_subscription": "A sua subscrição",
  "statsPage_Filter_data_from": "Filtrar dados de",
  "statsPage_Filter_data_to": "Filtrar dados para",
  "statsPage_to": "para",
  "statsPage_Reload": "Recarregar",
  "statsPage_Business_Metrics": "Métricas de negócio",
  "statsPage_Service_Metrics": "Métricas de serviço",
  "statsPage_Statistics_page": "Página de estatísticas",
  "imagesPage_Pictures_List": "Lista de imagens",
  "imagesPage_Search_by_name": "Procurar por nome",
  "imagesPage_No_pictures_available": "Não existem imagens disponíveis",
  "imagesPage_Name": "Nome",
  "imagesPage_Display_in_widget": "Mostrar no widget",
  "imagesPage_Type": "Tipo",
  "imagesPage_Update_date": "Data de atualização",
  "imagesPage_Mandatory": "Obrigatório",
  "imagesPage_Are_your_sure": "Tens a certeza?",
  "imagesPage_Delete": "Eliminar",
  "imagesPage_Yes": "Sim",
  "imagesPage_Cancel": "Cancelar",
  "imagesPage_Open_image": "Abrir imagem",
  "imagesPage_Edit": "Editar",
  "imagesPage_Delete_image": "Eliminar imagem",
  "CLP_The_purpose_of_Handiscover_2": "Incluímos também pontos que são \"fáceis\" de corrigir, mas provavelmente importantes numa perspetiva de acessibilidade.",
  "a11yUnits_The_title_has_been_translated": "O título foi traduzido",
  "statsPage_Statistics": "Estatísticas",
  "customerSupportPage_thankYou": "Obrigado!",
  "customerSupportPage_requestSuccessfully": "O seu pedido foi enviado com sucesso. O nosso serviço de apoio ao cliente tratará do seu pedido e entrará em contacto consigo o mais rapidamente possível.",
  "customerSupportPage_warning": "Aviso",
  "customerSupportPage_error": "Erro",
  "propertyListPage_showAll": "Mostrar tudo",
  "propertyListPage_completed": "Concluído",
  "propertyListPage_incomplete": "Incompleto",
  "dashboard": "Painel de controlo",
  "widget": "Widget",
  "property_type": "Tipo de propriedade",
  "category": "Categoria",
  "edit_widget": "Editar widget",
  "created": "Criado",
  "published": "Publicado",
  "unpublished": "Não publicado",
  "widget_info": "O widget de acessibilidade apresenta dados detalhados de acessibilidade previamente registados no Sistema de Gestão da Acessibilidade. Este widget permite criar melhores condições para que os visitantes planeiem a sua estadia com antecedência, através da visualização da acessibilidade disponível. O widget de acessibilidade é interativo, uma vez que todos os dados actualizados no sistema são reproduzidos no widget.",
  "view_live_widget": "Ver widget em direto",
  "no_widget_data_message": "Não dispomos de dados sobre widgets. Contacte a nossa equipa de apoio ao cliente.",
  "image_list": "Lista de imagens",
  "language_setting": "Definição da língua",
  "history": "História",
  "select_accessibility_unit": "Selecionar a unidade de acessibilidade",
  "add_new_image": "Adicionar nova imagem",
  "order": "Encomendar",
  "image": "Imagem",
  "description": "Descrição",
  "accessibility_unit": "Unidade de acessibilidade",
  "accessibility": "Acessibilidade",
  "displayed_in_widget": "Apresentado no widget",
  "current_image": "Imagem atual",
  "upload_new_picture": "Carregar nova imagem",
  "image_description": "Descrição da imagem",
  "image_order": "Ordem de imagem",
  "back_to_list": "Voltar à lista",
  "no_picture": "Sem imagem",
  "please_write_the_text_in": "Por favor, escreva o texto em",
  "yes_delete": "SIM, APAGAR",
  "delete_warning_text": "Se o fizer, o item desaparecerá do Widget e a norma será automaticamente actualizada, reflectindo a alteração.",
  "select_language_the_widget_provide": "Selecionar o idioma do widget",
  "changed_by": "Alterado por",
  "activity": "Atividade",
  "showing": "Exibição",
  "of": "de",
  "items": "artigos",
  "questionnaire": "Questionário",
  "we_are_showing_followings": "Estamos a mostrar as seguintes informações no seu Widget",
  "we_are_recommended_to_state": "Recomendamos que indique algumas informações práticas no Widget para os visitantes da sua propriedade. Se pretender editá-las, contacte o nosso serviço de apoio ao cliente",
  "select_what_you_want_to_show": "Seleccione o que pretende mostrar no widget",
  "practical_information": "Informações práticas",
  "you_can_add_maximum": "Pode acrescentar no máximo 3 frases",
  "for_the_best_experiences_in_widget": "Para obter as melhores experiências em Widget, ajudá-lo-emos se desejar acrescentar mais informações",
  "if_you_do_this_the_item_will_disappear": "Se fizer isso, o item desaparecerá do Widget",
  "you_can_write_free_texts": "Pode escrever textos livres para acrescentar às informações gerais, se necessário. Máximo 40 caracteres",
  "write_a_new_information": "Escrever uma nova informação",
  "you_can_drag_and_drop_the_block": "Pode arrastar e largar o bloco para alterar as encomendas. Seleccione a caixa de verificação para apresentar no widget.",
  "you_can_freely_change_the_images_ordering": "Pode alterar livremente a ordem das imagens arrastando e largando.",
  "preview": "Pré-visualização",
  "add_point_on_map": "Adicionar ponto no mapa",
  "LanguagesDropdown_Spanish": "espanhol",
  "LanguagesDropdown_Norwegian": "Norueguês",
  "LanguagesDropdown_Portuguese": "Português",
  "LanguagesDropdown_Ukrainian": "Ucraniano",
  "main_unit_image": "Imagem(ns) da unidade principal",
  "item_pictures": "Imagens de artigos",
  "please_choose_a_main_unit_image": "Escolha uma imagem da unidade principal",
  "please_choose_a_item_picture": "Escolha uma imagem do item",
  "button_settings_updated": "As definições dos botões foram actualizadas com êxito",
  "button_settings_created": "As definições dos botões foram criadas com êxito",
  "button_settings": "Definições dos botões",
  "webmaster_instruction": "Instruções para webmasters",
  "contract_has_expired": "O seu contrato expirou. O widget foi suspenso. Contactar a assistência",
  "webmaster_instructions_are_not_available": "De momento, não estão disponíveis instruções para webmasters. Contactar o suporte",
  "create_api_key": "Criar chave de API para esta empresa",
  "standard_instruction": "Instrução padrão",
  "google_tag_manager_instruction": "Instruções do Google Tag Manager"
}